import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./LoginPage.module.css";
import { useAuth } from "../contexts/AuthContext";
import Button from "components/common/Button";
import { useCart } from "contexts/CartContext";
import { Helmet } from "react-helmet";

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState(null);

  const { login } = useAuth();
  const { cartQuantity } = useCart();
  const location = useLocation();
  const navigate = useNavigate();

  const from = cartQuantity > 0 ? "/panier/finaliser-votre-commande" : location.state?.from || "/mon-compte";

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await login(username, password);
    if (!response.success) {
      console.log("Login failed", response);

      if (response.errors && response.errors.message) {
        setAlert({ type: 'error', message: response.errors.message });
        setTimeout(() => {
          setAlert(null);
        }, 5000);
        setErrors({});
      }
      if (response.errors && response.errors.errors) {
        setError(null);
        setErrors(response.errors.errors);
      }
    } else {
      setErrors({});
      setError(null);
      navigate(from, { replace: true });
    }
  };

  return (
    <div className="page-content">
      <Helmet>
        <title>Connexion - Pharos</title>
        <meta name="description" content="Connectez-vous à votre compte Pharos pour accéder à vos spectacles et gérer vos réservations." />
        <meta property="og:title" content="Connexion - Pharos" />
        <meta property="og:description" content="Connectez-vous à votre compte Pharos pour accéder à vos spectacles et gérer vos réservations." />
        <meta property="og:type" content="website" />
      </Helmet>
      <section className={`global-section ${styles.section}`}>
        <div className={`global-container ${styles.content}`}>
          <div className={styles.loginContainer}>
            <div className={styles.formContainer}>
              <h1 className="h2">S’identifier</h1>
              <p className={styles.Description}>Entrez vos identifiants pour accéder à votre compte.</p>
              <form onSubmit={handleSubmit}>
                {alert && (
                  <div className={`${styles.alert} ${styles[alert?.type]}`}>
                    {alert?.message}
                  </div>
                )}
                <ul className={styles.InputsList}>
                  <li>
                    <label htmlFor="username">Nom d'utilisateur (email)</label>
                    <input
                      type="text"
                      name="username"
                      value={username}
                      onChange={e => setUsername(e.target.value)}
                      placeholder="Nom d'utilisateur"
                    />
                    {error && <span className={styles.error}>{error}</span>}
                    {errors.email && <span className={styles.error}>{errors.email}</span>}
                  </li>
                  <li>
                    <label htmlFor="username">Mot de passe
                      <span className={styles.forgotPassword}>
                        <a href="/mot-de-passe-oublie">Mot de passe oublié ?</a>
                      </span>
                    </label>
                    <input
                      type="password"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      placeholder="Mot de passe"
                    />
                    {errors.password && <span className={styles.error}>{errors.password}</span>}
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      name="reset"
                      id="reset"
                      value={true}
                      onChange={e => { }}
                      aria-describedby="reset-description"
                    />
                    <label htmlFor="reset">Rester connecté(e)</label>
                    <span id="reset-description" className="sr-only">Cette option vous permet de rester connecté lors de vos prochaines visites</span>
                  </li>
                </ul>

                <Button type="submit">Se connecter</Button>

              </form>
              <div className={styles.Description}>Vous ne possédez pas encore de compte ? <Link className={styles.NavigateLink} to='/inscription'>Inscrivez-vous ici</Link></div>
            </div>
            <div className={styles.image}>
              <img src={`/images/ready-to-rock.webp`} alt="" aria-hidden="true"></img>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LoginPage;
